import { NgTemplateOutlet } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiAccordionModule } from 'omnium-ui/accordion';

@Component({
  selector: 'dbw-investor-viewer-accordion',
  imports: [OuiAccordionModule, NgTemplateOutlet],
  templateUrl: './investor-viewer-accordion.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './investor-viewer-accordion.component.scss',
})
export class InvestorViewerAccordionComponent {
  readonly anchorId = input<string | undefined>(undefined);
  readonly accordionTitle = input.required<string>();
  readonly itemsCount = input<number | undefined>(undefined);
  readonly loading = input<boolean>(false);
  readonly expanded = input<boolean>(false);
  readonly level = input<'title' | 'subtitle'>('title');
}
